<template>
    <div class="d-flex align-items-center my-3">
        <template v-if="checked">
            <Field name="size" :cc-value="radioValue" :value="radioValue + '_val_' + radioId" v-slot="{ field, meta }">
                <input :id="radioId + '_' + radioValue" v-bind="field" type="radio" :checked="checked" class="form-check-input float-start cursor-pointer" @click="emitter.emit('closeSizeForm', meta.initialValue)"/>
            </Field>
        </template>
        <template v-else>
            <Field name="size" :cc-value="radioValue" :id="radioId + '_' + radioValue" type="radio" :value="radioValue + '_val_' + radioId" :checked="checked" class="form-check-input float-start cursor-pointer" @click="emitter.emit('closeSizeForm')"/>
        </template>
        <label class="form-check-label float-start cursor-pointer" :for="radioId + '_' + radioValue">
            <b class="d-inline-block ms-3">{{ radioValue }}</b>
        </label>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';

    export default {
        props: ['radioId', 'radioValue', 'checked', 'sameFrontRear'],
        components: {
            Field
        }
    }
</script>
<style lang="scss" scoped>
	@import '@frontendAssets/sass/_variables.scss';

	.form-switch .form-check-input {
		background-color: $green;
		border-color: $green;
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
	.form-switch .form-check-input:focus {
		border-color: rgba(0, 0, 0, 0.25);
		border: none;
		outline: 0;
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
	.form-switch .form-check-input:checked {
		background-color: $green;
		border-color: $green;
		border: none;
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(255,255,255,1.0)'/></svg>");
	}
</style>